<template>
  <div class="task-row">
    <div v-if="isSubscription" class="subscription">
      <Icon :name="icon" width="40px" />
      <div class="link-text">
        <div class="title">
          {{ label }}
        </div>
        <div class="description">
          +{{ task.reward_amount }}
          <IconLP width="20px" height="20px" />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="title">
        {{ label }}
      </div>
    </div>

    <LeeaBtn v-if="!isTaken" @click="take" round width="80px"> Start </LeeaBtn>
    <LeeaBtn v-else @click="claim" round color="blue" :disabled="isCollected || !claimAllowed" width="80px"
      :completed="isCollected">
      Claim
    </LeeaBtn>
  </div>
</template>

<script lang="ts" setup>
import { api } from '@/api'
import { TaskType, type Task } from '@/api/tasks/types'
import { icons, labels } from '@/data/tasks'
import Icon from '@/components/Icon.vue'
import { computed, ref } from 'vue'
import { useTasksStore } from '@/stores/tasks'
import LeeaBtn from '@/components/LeeaBtn.vue'
import { useUserStore } from '@/stores/user'
import IconLP from './Icons/IconLP.vue'

const props = defineProps<{ task: Task }>()
const store = useTasksStore()
const userStore = useUserStore()
const isSubscription = props.task.type === TaskType.SUBSCRIPTION
const icon = icons[props.task.name]
const label = labels[props.task.name]

const isTaken = computed(() => props.task.user_tasks[0])
const isCollected = ref(props.task.user_tasks[0]?.is_collected)
const claimAllowed = computed(() => props.task.user_tasks[0]?.is_collected === false)

const take = async () => {
  window.open(props.task.link)
  await api.tasks.take({
    payload: {
      taskId: props.task.id
    }
  })
  store.fetchTasks()
}

const claim = async () => {
  const { success } = await api.tasks.claim({
    payload: {
      userTaskId: props.task.user_tasks[0].id
    }
  })
  isCollected.value = success
  userStore.fetchUser()
  store.fetchTasks()
}
</script>

<style lang="scss" scoped>
.task-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #e9e9e9;
  }

  @media (max-height: 600px) {
    padding: 8px 0;
  }
}

.title {
  color: var(--black-color);
  font-family: 'Forma DJR Display', sans-serif;
  font-weight: bold;
  margin-bottom: 4px;
}

.description {
  color: var(--gray-dark-color);
  font-family: 'Forma DJR Display', sans-serif;
  display: flex;
  align-items: center;
  gap: 10px;

  .icon {
    fill: var(--gray-dark-color);
  }
}

.subscription {
  display: flex;
}

.link-text {
  margin-left: 8px;
  height: 40px;
}
</style>
